export default __webpack_public_path__ + "static/media/wifi.4211c732.svg";